import { render, staticRenderFns } from "./modalConfirm.vue?vue&type=template&id=1773f743&scoped=true"
import script from "./modalConfirm.vue?vue&type=script&lang=js"
export * from "./modalConfirm.vue?vue&type=script&lang=js"
import style0 from "./modalConfirm.vue?vue&type=style&index=0&id=1773f743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1773f743",
  null
  
)

export default component.exports